import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import './utils/xuantie-hljs'
import './assets/styles/global.css'

Vue.config.productionTip = false

Vue.use(i18n)
Vue.use(mavonEditor)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
